export default "__VITE_ASSET__Dk9b2LPI__"